export default "__VITE_ASSET__OEJZIssd__"